webpackJsonp([406],{

/***/ 1241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  head: { "title": " | VUX - Vue 移动端 UI 组件库", "ignoreSuffixChar": "|" }
});

/***/ }),

/***/ 2195:
/***/ (function(module, exports, __webpack_require__) {

var disposed = false
var Component = __webpack_require__(67)(
  /* script */
  __webpack_require__(1241),
  /* template */
  __webpack_require__(2693),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)
Component.options.__file = "/data/vux/home/websites/vux-repo/docs/node_modules/v-markdown-loader/_cache/v2.1.0_zh-CN-291.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key.substr(0, 2) !== "__"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] v2.1.0_zh-CN-291.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-472ab9f1", Component.options)
  } else {
    hotAPI.reload("data-v-472ab9f1", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

module.exports = Component.exports


/***/ }),

/***/ 2693:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Actionsheet")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持数组定义菜单 #950 @wuchuguang")])]), _vm._v(" "), _c('h2', [_vm._v("Datetime")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复"), _c('code', [_vm._v("label")]), _vm._v("宽度没有受限于"), _c('code', [_vm._v("group")]), _vm._v("设置")])]), _vm._v(" "), _c('h2', [_vm._v("Icon")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 更新"), _c('code', [_vm._v("WeUI")]), _vm._v("样式到最新版本")]), _vm._v(" "), _c('li', [_vm._v("[change] "), _c('code', [_vm._v("type")]), _vm._v("参数由下划线变为中划线，组件内部做了兼容保证升级时无影响")])]), _vm._v(" "), _c('h2', [_vm._v("Marquee")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 新组件")])]), _vm._v(" "), _c('h2', [_vm._v("Msg")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 新组件")])]), _vm._v(" "), _c('h2', [_vm._v("Search")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 更新到"), _c('code', [_vm._v("WeUI")]), _vm._v("最新代码")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 当"), _c('code', [_vm._v("value")]), _vm._v("为空时，不显示清除按钮")])]), _vm._v(" "), _c('h2', [_vm._v("ViewBox")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 增加"), _c('code', [_vm._v("body-padding-top")]), _vm._v("及"), _c('code', [_vm._v("body-padding-bottom")]), _vm._v("方便设定上下"), _c('code', [_vm._v("padding")]), _vm._v("值")])]), _vm._v(" "), _c('h2', [_vm._v("XButton")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 更新到 "), _c('code', [_vm._v("WeUI")]), _vm._v(" 最新版本")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持 "), _c('code', [_vm._v("prop:isLoading")])])]), _vm._v(" "), _c('h2', [_vm._v("XDialog")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复"), _c('code', [_vm._v("transition")]), _vm._v("绑定")])]), _vm._v(" "), _c('h2', [_vm._v("XNumber")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 升级"), _c('code', [_vm._v("WeUI")]), _vm._v("样式")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复"), _c('code', [_vm._v("label")]), _vm._v("样式不受控于"), _c('code', [_vm._v("group")]), _vm._v("设置")]), _vm._v(" "), _c('li', [_vm._v("[feature] 支持"), _c('code', [_vm._v("align")]), _vm._v("属性")])])])
}]}
module.exports.render._withStripped = true
if (false) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-472ab9f1", module.exports)
  }
}

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2195);

/***/ })

});


// WEBPACK FOOTER //
// 406.63bc6d40.js